import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { formTextProps as Props } from "../../types/doctorInfo.types";

const FormText: React.FC<Props> = ({ number, title, optional }) => {
  return (
    <React.Fragment>
      <Box sx={{ maxWidth: { xs: "100%", sm: "100%", lg: "100%" } }}>
        <Typography
          variant="h5"
          gutterBottom
          component="div"
          sx={{
            letterSpacing: 0,
            color: "#333333",
            opacity: 0.3,
            fontFamily: "Avenir",
            fontSize: { xs: "17px", sm: "19px", md: "21px", xl: "24px" },
            lineHeight: { xs: "25px", sm: "27px", md: "29px", xl: "34px" },
            mb: 0,
          }}
        >
          {number}
        </Typography>
        <Typography
          variant="h5"
          gutterBottom
          component="div"
          sx={{
            textAlign: "left",
            fontFamily: "Avenir",
            letterSpacing: 0,
            color: "#333333",
            opacity: 1,
            fontSize: { xs: "22px", sm: "23px", md: "25px", xl: "30px" },
            lineHeight: { xs: "25px", sm: "27px", md: "29px", xl: "36px" },
            display: "inline-flex",
            flexDirection: { xs: "column", sm: "column", md: "unset" },
            borderBottom: "1px solid #94949533",
          }}
        >
          {title}
          {optional && (
            <Typography
              variant="h5"
              gutterBottom
              component="div"
              sx={{
                textAlign: "left",
                fontFamily: "Avenir",
                letterSpacing: 0,
                color: "#333333",
                opacity: 0.6,
                fontSize: { xs: "17px", sm: "19px", md: "21px", xl: "26px" },
                lineHeight: { xs: "25px", sm: "27px", md: "29px", xl: "36px" },
                fontStyle: "italic",
                mb: 0,
              }}
            >
              {optional}
            </Typography>
          )}
        </Typography>
      </Box>
    </React.Fragment>
  );
};

export default FormText;
